<template>
  <div
    v-if="columnsData?.attributes?.slideType==='full-image'"
    class="grid-x content-wrapper"
    :class="containAlignObject"
  >
    <div class="promoSlide-item large-12 medium-12 small-12 image-content-wrapper">
      <ImageMap :image-map="columnsData?.primaryImageMap" />
    </div>
    <div
      class="promoSlide-item-copy grid-y large-6 medium-12 small-12"
    >
      <div :class="{'copy-wrapper':checkCopyPresent}">
        <PromoSlideshowCopy :copy="columnsData" />
        <div
          v-if="columnsData?.ctas?.children?.length"
          class="ctas-container"
          :class="ctasClassObject"
        >
          <Ctas
            :ctas="columnsData?.ctas"
            :alignment="columnsData?.attributes?.alignment"
          />
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="grid-x content-wrapper"
  >
    <template
      v-for="(col, index) in gridCols"
      :key="index"
    >
      <div :class="['grid-x cell', col?.wrapperClass, {'image-content-wrapper': col?.type?.includes('I')}]">
        <div
          :class="['promo-content', {'text-content': col?.type?.includes('C')}] "
        >
          <template v-if="col?.type?.includes('I')">
            <div
              v-if="columnsData?.attributes?.slideType!=='4I4C4I' && !multiImageSlide.includes(columnsData?.attributes?.slideType)"
              class="promoSlide-item"
            >
              <ImageMap :image-map="columnsData?.primaryImageMap" />
            </div>
            <div
              v-if="multiImageSlide.includes(columnsData?.attributes?.slideType)"
              class="grid-x promoSlide-item"
            >
              <div class="cell small-12 medium-6 large-6">
                <ImageMap :image-map="columnsData?.primaryImageMap" />
              </div>
              <div class="cell small-12 medium-6 large-6">
                <ImageMap :image-map="columnsData?.secondaryImageMap" />
              </div>
            </div>
            <div
              v-if="columnsData?.attributes?.slideType==='4I4C4I'"
              class="promoSlide-item"
            >
              <ImageMap
                v-if="index===0"
                :image-map="columnsData?.primaryImageMap"
              />
              <ImageMap
                v-if="index===2"
                :image-map="columnsData?.secondaryImageMap"
              />
            </div>
          </template>
          <template v-else>
            <div class="promoSlide-item-copy">
              <div :class="{'copy-wrapper':checkCopyPresent}">
                <PromoSlideshowCopy :copy="columnsData" />
                <div
                  v-if="columnsData?.ctas?.children?.length"
                  class="ctas-container"
                  :class="ctasClassObject"
                >
                  <Ctas
                    :ctas="columnsData?.ctas"
                    :alignment="columnsData?.attributes?.alignment"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ImageMap from '../imageMap/ImageMap';
import PromoSlideshowCopy from './PromoSlideshowCopy';
import Ctas from '../ctas';

const props = defineProps({
  columnsData: {
    type: Object,
    default: () => {},
  },
});

const multiImageSlide = ['7I5C', '5C7I'];
const ctasClassObject = computed(() => ({
  linkClass: props.columnsData?.ctas?.attributes?.linkStyle === 'underlinedText',
  buttonClass: (props.columnsData?.ctas?.attributes?.linkStyle === 'primaryButton' || props.columnsData?.ctas?.attributes?.linkStyle === 'secondaryButton'),
  'align-right': props.columnsData?.attributes?.alignment === 'right',
  'align-left': props.columnsData?.attributes?.alignment === 'left',
  'align-center': props.columnsData?.attributes?.alignment === 'center',
}));
const containAlignObject = computed(() => ({
  'align-right': props.columnsData?.attributes?.alignment === 'right',
  'align-left': props.columnsData?.attributes?.alignment === 'left',
  'align-center': props.columnsData?.attributes?.alignment === 'center',
}));
const gridCols = computed(() => {
  const columns = props.columnsData?.attributes?.slideType.match(/(\d+\/\d+C)|(\d+\/\d+I)|(\d+I)|(\d+C)/gi);
  return columns.map((col) => {
    const colSize = col.match(/\d+/gi)[0];
    const large = colSize;
    const mid = (col === '4I' && props.columnsData?.attributes?.slideType === '4I4C4I') ? 6 : 12;
    const alignment = `align-${props.columnsData?.attributes?.copyOffAlignment === 'top' ? 'top' : 'middle'}`;
    return {
      type: col,
      wrapperClass: `${alignment} small-12 medium-${mid} large-${large}`,
    };
  });
});

const checkCopyPresent = computed(() => {
  const textAttributes = [
    'heading',
    'disclaimer',
    'caption',
    'subBody',
    'subHeading',
    'smallLink',
    'body',
    'subHeading2',
    'body2',
    'subHeading3',
    'body3',
    'eyebrow',
  ];

  let result = false;
  textAttributes.forEach((e) => {
    if (props.columnsData?.attributes?.[e]) {
      result = true;
    }
  });

  return result;
});
</script>

<style lang="scss" scoped>
.content-wrapper {
  height: 100%;
  width: 100%;
  .image-content-wrapper {
    background-color: $white;
  }
  .promo-content {
    width: 100%;
  }
  .promoSlide-item {
    display: flex;
    align-items: center;
  }
  .promoSlide-item-copy {
    justify-content: center;
    .copy-wrapper {
      display: flex;
      flex-direction: column;
      .ctas-container.buttonClass, .ctas-container.linkClass {
        display: flex;
        :deep() {
          .ctas-cont {
            row-gap: rem-calc(16px);
            column-gap: rem-calc(16px);
          }
        }
      }
    }
  }
}
.promo-4I4C4I .promoSlide-item-copy {
  order: 1;
}
.promo-full-image .content-wrapper {
  position: relative;
}
//large
@include breakpoint(large) {
  .content-wrapper {
    // max-height: rem-calc(600px);
    // overflow: hidden;
    .promoSlide-item-copy {
      .copy-wrapper {
        width: 80%;
        margin: 0 10%;
        padding: rem-calc(0 20px);
        :deep() {
          .logo {
            margin: rem-calc(16px 0 0 0);
          }
          .heading {
            padding-top: rem-calc(16px);
          }
        }
      }
    }
  }
  .promo-4I4C4I {
    .promoSlide-item-copy {
      .copy-wrapper {
        padding: 0;
      }
    }
    .promoSlide-item:last-child {
      order: 1;
    }
  }
  .promo-full-image {
    position: relative;
    .promoSlide-item-copy {
      .copy-wrapper {
        padding: 0;
        margin: 0;
        width: 100%;
      }
      height: max-content;
      position: absolute;
      top: 0;
      padding-left: rem-calc(80px);
      padding-right: rem-calc(80px);
      bottom: 0;
      margin: auto;
    }
  }
  .promo-4C8I, .promo-6C6I, .promo-7C5I, .promo-5C7I {
    flex-direction: row;
  }
}
//Tablet 600->1023
@media screen and (max-width: #{map-get($breakpoints, 'large')-1}) {
  .promoSlide-item-copy {
    .copy-wrapper {
      width: 90%;
      margin: 2rem 5%;
      :deep() {
        .logo {
          margin: rem-calc(8px 0 0 0);
        }
        .heading {
          padding-top: rem-calc(8px);
        }
      }
    }
  }
  .promoSlide-item {
    max-height: 27rem;
    overflow: hidden;
  }
  .promo-6C6I {
    .promoSlide-item-copy {
      .copy-wrapper {
        width: 90%;
        margin: 2.5rem 5%;
      }
    }
  }
  .promo-4C8I, .promo-6C6I, .promo-7C5I, .promo-5C7I {
    .content-wrapper > div:first-child {
      order: 1;
    }
  }
  .promo-4I4C4I {
    .content-wrapper > div:nth-child(2) {
      order: 1;
    }
  }
}
</style>
<style lang="scss" brand="mcom" scoped>
@import './../../scss/globalAttributes.mcom.scss';
</style>

<style lang="scss" brand="bcom" scoped>
@import './../../scss/globalAttributes.bcom.scss';
</style>
